import type { PercursoTotals } from 'shared';
import { BADGE_UNIVERSO_COLORS } from 'shared';
import { formatHours } from '@/lib/percurso';

/** The percurso in figures: days, activities, badges, equipment hours, universos. */
export default function PercursoSummary({ totals }: { totals: PercursoTotals }) {
  const tiles = [
    { value: String(totals.days), label: totals.days === 1 ? 'dia' : 'dias' },
    { value: String(totals.sessions), label: totals.sessions === 1 ? 'atividade' : 'atividades' },
    { value: String(totals.badges), label: totals.badges === 1 ? 'badge' : 'badges' },
    { value: `${formatHours(totals.equipmentHours)} h`, label: 'equipamento' },
  ];
  const universos = totals.universos ?? [];

  return (
    <section aria-label="Resumo do percurso" className="space-y-3">
      <dl className="grid grid-cols-4 gap-2">
        {tiles.map((tile) => (
          <div
            key={tile.label}
            className="flex flex-col-reverse rounded-2xl border border-border bg-card px-1 py-3 text-center shadow-sm"
          >
            <dt className="text-[10px] font-semibold leading-tight text-muted-foreground">{tile.label}</dt>
            <dd className="text-xl font-black text-foreground">{tile.value}</dd>
          </div>
        ))}
      </dl>

      {universos.length > 0 && (
        <ul className="flex flex-wrap gap-2" aria-label="Universos por onde passou">
          {universos.map((u) => (
            <li
              key={u.universo}
              className="rounded-full px-3 py-1 text-xs font-bold"
              style={{
                backgroundColor: BADGE_UNIVERSO_COLORS[u.universo].bg,
                color: BADGE_UNIVERSO_COLORS[u.universo].text,
              }}
            >
              {u.universo}
              <span className="sr-only">
                : {u.sessions} {u.sessions === 1 ? 'atividade' : 'atividades'}, {u.badges}{' '}
                {u.badges === 1 ? 'badge' : 'badges'}
              </span>
              <span aria-hidden="true"> · {u.sessions + u.badges}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
